module.exports = __webpack_public_path__ + "static/media/riskDiabetes.66a2f518.mp3";